import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg";
import DeleteModal from "../../../components/DeleteModal";
import svg2 from "../../../assets/svg/svg2.svg";
import {
  fetchBanks,
  fetchData,
  fetchSubwalletDropdown,
} from "../../../features/fetch/fetchSlice";
import CardLoading from "../../../components/CardLoading";
import BreadCrumb from "../../../layout/BreadCrumb";
import AddStandingModal from "./modal/AddStandingModal";
import Search from "../../../components/Search";
import useModalToggle from "../../../custom_hooks/useModalToggle";
import { dateForHumans, numberWithCommas } from "../../../utils";
import { deleteRequest } from "../../../features/save/saveSlice";
import svg69 from "../../../assets/svg/svg69.svg";
import deleteSvg from "../../../assets/svg/delete-red.svg";

export default function StandingOrderTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const url = "api/v1/payments/fetch-standing-orders";
  const urlCat = "api/v1/payments/fetch-payment-categories";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);

  const { open, handleCancel, handleOpen } = useModalToggle();

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      deleteRequest({
        url: `api/v1/payments/delete-standing-order/${prodd?.soId}`,
      })
    );
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      setIsModalOpenDelete(false);
      fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleAdd = async () => {
    await setProdd("");
    await handleOpen();
  };

  const handleEdit = () => {
    handleOpen();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex gap-x-[.75rem] items-center py-[.5rem]"
        >
          <img src={svg69} alt="svg69" className="w-4 h-4" />
          <span className="whitespace-nowrap">Edit</span>
        </Link>
      ),
    },
    {
      key: "divider-1",
      type: "divider",
    },
    {
      key: "2",
      label: (
        <Link
          onClick={showModalDelete}
          className="flex gap-x-[.75rem] items-center py-[.5rem]"
        >
          <img src={deleteSvg} alt="deleteSvg" className="w-4 h-4" />
          <span className="whitespace-nowrap">Delete</span>
        </Link>
      ),
    },
    {
      key: "divider-2",
      type: "divider",
    },
  ];

  const columns = [
    {
      title: "Subscription Name",
      dataIndex: "soName",
      sorter: (a, b) => a.soName.localeCompare(b.soName),
    },
    {
      title: "Start Date",
      dataIndex: "soStartDate",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      sorter: (a, b) => a.soStartDate - b.soStartDate,
    },
    {
      title: "End Date",
      dataIndex: "soEndDate",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      sorter: (a, b) => a.soEndDate - b.soEndDate,
    },

    {
      title: "Source Wallet",
      dataIndex: "soWalName",
      sorter: (a, b) => a.soWalName.localeCompare(b.soWalName),
    },

    {
      title: "Total Amount",
      dataIndex: "soAmount",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.soAmount - b.soAmount,
    },
    {
      title: "Category",
      dataIndex: "soPcName",
      sorter: (a, b) => a.soPcName.localeCompare(b.soPcName),
    },
    {
      title: "Sub Category",
      dataIndex: "soPscName",
      sorter: (a, b) => a.soPscName.localeCompare(b.soPscName),
    },
    {
      title: "Receiver Mobile",
      dataIndex: "soReceiverMobileNo",
      sorter: (a, b) =>
        a.soReceiverMobileNo.localeCompare(b.soReceiverMobileNo),
    },
    {
      title: "Benefitiary Bank",
      dataIndex: "soBeneficiaryBankName",
      sorter: (a, b) => a.soBeneficiaryBankName.localeCompare(b.soBeneficiaryBankName),
    },
    {
      title: "Account Number",
      dataIndex: "soBeneficiaryAccount",
      sorter: (a, b) =>
        a.soBeneficiaryAccount.localeCompare(b.soBeneficiaryAccount),
    },
    {
      title: "Frequency",
      dataIndex: "soFrequency",
      sorter: (a, b) => a.soFrequency.localeCompare(b.soFrequency),
    },
    {
      title: "Reason",
      dataIndex: "soReason",
      sorter: (a, b) => a.soReason.localeCompare(b.soReason),
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [searchInput, setsearchInput] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        soName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  async function fetchCategoryData() {
    dispatch(
      fetchData({
        url: urlCat,
        start: 0,
        limit: null,
      })
    );
  }
  async function fetchSubWalletData() {
    dispatch(
      fetchSubwalletDropdown({
        url: `api/v1/wallet/sub/${user?.disbursementWalId}`,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
    fetchCategoryData();
    fetchSubWalletData();
    dispatch(
      fetchBanks({
        url: "api/v1/payments/fetch-banks",
      })
    );
  }, []);
  const breadList = [
    {
      title: (
        <div className="flex items-center gap-[.25rem]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clipPath="url(#clip0_627_13942)">
              <path
                d="M13.7899 6.89067L7.75241 0.856289L7.34772 0.451602C7.25551 0.360003 7.13082 0.308594 7.00085 0.308594C6.87087 0.308594 6.74618 0.360003 6.65397 0.451602L0.211783 6.89067C0.117301 6.98478 0.0426296 7.09687 -0.00782254 7.22031C-0.0582747 7.34376 -0.0834854 7.47607 -0.0819665 7.60942C-0.0757165 8.15942 0.382096 8.59848 0.932096 8.59848H1.59616V13.6875H12.4055V8.59848H13.0837C13.3508 8.59848 13.6024 8.49379 13.7915 8.30473C13.8846 8.21193 13.9583 8.10159 14.0085 7.98009C14.0586 7.8586 14.0842 7.72836 14.0837 7.59692C14.0837 7.33129 13.979 7.07973 13.7899 6.89067ZM7.87585 12.5625H6.12585V9.37504H7.87585V12.5625ZM11.2805 7.47348V12.5625H8.87585V9.00004C8.87585 8.65473 8.59616 8.37504 8.25085 8.37504H5.75085C5.40553 8.37504 5.12585 8.65473 5.12585 9.00004V12.5625H2.72116V7.47348H1.22116L7.00241 1.69691L7.36335 2.05785L12.7821 7.47348H11.2805Z"
                fill="black"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <clipPath id="clip0_627_13942">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Home</span>
        </div>
      ),
      href: "/#/home",
    },
    {
      title: (
        <div className="text-lighGold text-[16px]">Standing Order Setup</div>
      ),
    },
  ];
  if (loading && !searchInput && !open) return <CardLoading />;
  return (
    <div className="w-full h-full overflow-y-scroll">
      <div className="justify-between items-center white_card">
        <BreadCrumb
          breadList={breadList}
          header={"Standing Order Information"}
          info={"Create your standing order here"}
          btn={true}
          btnTitle="Add Standing Order "
          onClick={handleAdd}
          btnSvg={svg2}
        />
      </div>

      <div className="white_card w-full flex-1 min-h-[70vh] flex-col  mt-[1.25rem]">
        <div className="flex gap-5 lg:items-center justify-between lg:flex-row flex-col">
          <h3 className="heading_4 mt-[1.25rem]">Standing Order Details</h3>
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>
        </div>

        <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
          <section>
            <Table
              rowSelection={false}
              className="mt-[1.31rem] w-full"
              scroll={{
                x: "auto",
              }}
              rowKey={(record) => record?.soId}
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                position: ["bottomCenter"],
                current: pageIndex + 1,
                total: count,
                pageSize: pageSize,
                onChange: (page, size) => {
                  setPageIndex(page - 1);
                  setPageSize(size);
                  fetchTableData(page - 1, size);
                },
                showSizeChanger: false,
                hideOnSinglePage: true,
              }}
            />
          </section>
        </div>
      </div>

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={saving}
        content={`Are you sure you want to delete  ${prodd?.soName} `}
        title={`Delete ${prodd?.soName}`}
      />

      <AddStandingModal
        handleFetchData={fetchTableData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
      />
    </div>
  );
}
